import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  display: inline-block;
`

export const NavItem = styled.div`
  width: 40px;
  color: #252525;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  margin: 3px 5px;
  padding: 8px 15px;
  cursor: pointer;

  svg {
    width: 26px;
    height: 26px;
  }

  &:hover, &:focus {
    box-shadow: 0px 2px 10px -6px #252525;
  }

  &.active {
    background-color: #FFFFFF;
    box-shadow: 0px 2px 10px -6px #252525;
  }

  &.active svg {
    color: #FFC100 !important;
  }
`

export const Menu = styled.ul`
  position: absolute;
  top: 0;
  ${({ position }) => (position === 'right' ? 'left: 100%;' : 'right: 100%;')}
  background-color: #FFFFFF;
  border-radius: 10px;
  box-shadow: 0px 2px 10px -6px #252525;
  list-style: none;
  padding: 0;
  margin: 0;
  min-width: 200px;
  z-index: 10;
  overflow: hidden;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  transition: opacity 0.3s ease, transform 0.3s ease;
  pointer-events: ${({ isOpen }) => (isOpen ? 'auto' : 'none')};
  transform: ${({ isOpen, position }) => (
    isOpen
      ? 'translateX(0)'
      : position === 'right'
        ? 'translateX(-20px)'
        : 'translateX(20px)'
  )};
`

export const MenuItem = styled.li`
  color: #252525;
  border-bottom: 1px solid #F0F0F0;
  padding: 10px 15px;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #F0F0F0;
  }
`

export const Label = styled.label`
  text-align: center;
  color: #FFFFFF;
  margin: 0px;
`
